import { Box, Flex } from '@mantine/core'
import dayjs from 'dayjs'

import {
  useAcceptRecommendation,
  useRejectRecommendation,
} from '@/modules/actionPlan/pages/components/RecommendationItem/RecommendationItem.conifg'
import type { RecommendationItemProps } from '@/modules/actionPlan/pages/components/RecommendationItem/RecommendationItem.types'

import { Button } from '@/components/Button/Button'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import { formatMoney } from '@/helpers/formatMoney.helper'

import classes from './RecommendationItem.module.css'

export function RecommendationItem({
  recommendation,
}: RecommendationItemProps) {
  const { amount, dueDate, id, name } = recommendation

  const { acceptRecommendation } = useAcceptRecommendation(id)
  const { rejectRecommendation } = useRejectRecommendation(id)

  return (
    <Flex
      className={classes.container}
      direction="column"
      justify="space-between"
    >
      <Box>
        <Title mb={8} variant="h2_small">
          {name}
        </Title>
        <Flex gap={4}>
          <Text variant="body_1_grey">Complete:</Text>
          <Text variant="body_1_semibold_red">
            by {dayjs(dueDate).format('MMM D, YYYY')}
          </Text>
        </Flex>

        <Flex gap={4}>
          <Text variant="body_1_grey">Goal:</Text>
          <Text variant="body_1_semibold_red">{formatMoney(+amount)}</Text>
        </Flex>
      </Box>

      <Flex className={classes.buttons} gap={8}>
        <Button onClick={rejectRecommendation} variant="outline-small">
          Reject
        </Button>

        <Button onClick={acceptRecommendation} variant="primary-small">
          Accept
        </Button>
      </Flex>
    </Flex>
  )
}
